import type Transition from '@ember/routing/transition';
import config from 'uplisting-frontend/config/environment';

interface IRouterHelper {
  targetRoute: string | undefined;
  activeTransition: Transition | undefined;
}

export const routerHelper: IRouterHelper = {
  targetRoute: undefined,
  activeTransition: undefined,
};

export function animatedTransition(
  cb: () => void,
  startCallbackBeforeViewTransition = false,
): void {
  if (!window.document.startViewTransition || config.IS_TEST) {
    cb();
  } else {
    // if it's a `route transition`, we want to call it immediately
    // and wait for promise to complete inside `view transition`
    // otherwise - cb should be called inside `view transition` to be animated
    const transition = startCallbackBeforeViewTransition ? cb() : undefined;

    window.document.startViewTransition(() =>
      startCallbackBeforeViewTransition ? transition : cb(),
    );
  }
}
